import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export var LogoSources;
(function (LogoSources) {
    LogoSources["TeeWhite"] = "/assets/TeeWhite.svg";
    LogoSources["TeeTimeWhite"] = "/assets/TeeTimeWhite.svg";
    LogoSources["TeeTimeGreen"] = "/assets/TeeTimeGreen.svg";
    LogoSources["TeeTimeButton"] = "/assets/TeeTimeButton.svg";
    LogoSources["Tee"] = "/assets/Tee.svg";
})(LogoSources || (LogoSources = {}));
export const LogoComponent = React.memo(({ themeMode = 'light', size = 'medium', lightLogoSrc = LogoSources.TeeTimeGreen, darkLogoSrc = LogoSources.TeeTimeGreen, style, alt, }) => {
    const logoSizes = {
        small: { height: '42px', width: 'auto' },
        medium: { height: '48px', width: 'auto' },
        large: { height: '72px', width: 'auto' },
        extraLarge: { height: '124px', width: 'auto' },
    };
    const logoSrc = themeMode === 'dark' ? darkLogoSrc : lightLogoSrc;
    const computedAlt = alt ?? `${themeMode === 'dark' ? 'Dark' : 'Light'} Mode Logo`;
    return (_jsx("img", { src: logoSrc, alt: computedAlt, style: {
            ...logoSizes[size],
            ...style,
        } }));
});
//# sourceMappingURL=LogoComponent.js.map